import { SERVICE_TIME_FORMAT } from 'app/constants/date'
import moment from 'moment'
import { get, post } from '../baseService'
import { NewsModel } from 'app/models/newsModel'


const create = () => {
  const getMessages = () => get('/config-api/message/list')

  const addMessage = (message: NewsModel) =>
    post(
      '/config-api/message/create',
      {
        text: message.text,
        groups: message.groups,
        status: message.status,
        deleted: message.deleted,
        startDate: message.startDate
          ? moment(message.startDate).format(SERVICE_TIME_FORMAT)
          : null,
        endDate: message.endDate
          ? moment(message.endDate).format(SERVICE_TIME_FORMAT)
          : null,
      },
      false,
    )

  const editMessage = (message: NewsModel) =>
    post(
      '/config-api/message/edit',
      {
        id: message.id,
        text: message.text,
        groups: message.groups,
        status: message.status,
        deleted: message.deleted,
        startDate: message.startDate
          ? moment(message.startDate).format(SERVICE_TIME_FORMAT)
          : null,
        endDate: message.endDate
          ? moment(message.endDate).format(SERVICE_TIME_FORMAT)
          : null,
      },
      false,
    )

  return {
    getMessages,
    addMessage,
    editMessage,
  }
}

export default {
  create,
}
